import type { PayflowInitializer } from '@ctct/application-layer';
import { AlertWidget, ThankYouWidget, useAlertWidget, useIsSmsBundle, useThankYouWidget } from '@ctct/react-app-layer';
import type { OrderSummaryHooks, PayflowTopBarHooks } from '@ctct/state-client-layer';
import { usePayflowPageStore } from '@ctct/state-client-layer';

interface Props {
  initializer: PayflowInitializer;
  externalHooks: {
    useReturnUrl: PayflowTopBarHooks['useReturnUrl'];
    useReturnLabel: PayflowTopBarHooks['useReturnLabel'];
    useIsXeroAddonSelected: OrderSummaryHooks['useIsXeroAddonSelected'];
  };
}

const alertHooks = {
  useAlerts: () => usePayflowPageStore((state) => state.alerts),
};

export const ConfirmationPage = ({ initializer, externalHooks }: Props) => {
  const isSmsBundle = useIsSmsBundle();

  const props = useThankYouWidget({
    initializer,
    externalHooks,
    version: isSmsBundle ? 'sms-bundle' : 'regular',
  });

  const alertProps = useAlertWidget({
    initializer,
    pageStore: usePayflowPageStore,
    hooks: alertHooks,
  });

  return (
    <div className="payflow-v2-thank-you">
      <div className="payflow-v2__alerts-wrapper">
        <AlertWidget {...alertProps} />
      </div>
      <ThankYouWidget {...props} />
    </div>
  );
};
